import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createSlots as _createSlots, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_loading = _resolveComponent("ontos-dialog-loading")!
  const _component_ontos_instance_card = _resolveComponent("ontos-instance-card")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_dialog_action_row = _resolveComponent("ontos-dialog-action-row")!
  const _component_ontos_busy_overlay = _resolveComponent("ontos-busy-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_ontos_instance_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ontos_dialog_loading)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_ontos_instance_card, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_ontos_page_header, {
                  title: _ctx.title,
                  subtitle: _ctx.subtitle,
                  accent: _ctx.accent,
                  level: 2
                }, _createSlots({ _: 2 }, [
                  (_ctx.$slots.actions)
                    ? {
                        name: "actions",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "actions")
                        ]),
                        key: "0"
                      }
                    : undefined,
                  (_ctx.$slots.controls)
                    ? {
                        name: "controls",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "controls")
                        ]),
                        key: "1"
                      }
                    : undefined
                ]), 1032, ["title", "subtitle", "accent"])
              ]),
              _: 3
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }),
            _createVNode(_component_ontos_dialog_action_row, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "more-actions"),
                _createVNode(_component_v_btn, {
                  size: "small",
                  color: "primary",
                  loading: _ctx.saving,
                  disabled: _ctx.saving || _ctx.saveDisabled,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      start: ""
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("mdi-floppy", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$tt('save')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 3
            })
          ]),
          _: 3
        })),
    _createVNode(_component_ontos_busy_overlay, { model: _ctx.saving }, null, 8, ["model"])
  ], 64))
}